import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TypeWriterEffect from 'react-typewriter-effect';
import './App.css';

export default function Hero() {
    let size = window.innerWidth;
    let browserComp = navigator.vendor;

    return (
            <div className={browserComp !== "Apple Computer, Inc." ? `hero` : `heroIos`}>
            {size > 600 && browserComp !== "Apple Computer, Inc." ?
                <img className="hero-img" style={{maxWidth:340,maxHeight:440}} src="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Feduard_sala_profile_pic.avif?alt=media&token=a69ebca1-406a-4a05-b454-d90f044180ba" alt="ed pic" />
                : size <= 600 && browserComp !== "Apple Computer, Inc." ?
                <img className="hero-img" style={{maxWidth:340,maxHeight:440}} src="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Feduard_sala_profile_pic_mobile.avif?alt=media&token=0be43570-cbdd-476a-858e-6f0d4ca61e5b" alt="ed pic" />
                : size > 600 ?
                <img className="hero-img" src="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Feduard_sala_profile_pic.png?alt=media&token=cd374340-f28e-482f-87db-ef4aa7443888" alt="ed pic" />
                :
                <img className="hero-img" src="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Feduard_sala_profile_pic.png?alt=media&token=cd374340-f28e-482f-87db-ef4aa7443888" alt="ed pic" />
            }
            <Paper elevation={2} color="primary" className="hero-message">
                <div>
                    <Typography>
                        Hi! I am <span className="accent-color">Eduard Sala</span>,
                    </Typography>
                    <TypeWriterEffect
                        textStyle={{
                            fontSize: '1.25rem',
                            fontWeight: "400",
                        }}
                        startDelay={1750}
                        cursorColor="#3F3D56"
                        multiText={[
                            'a product manager',
                            'an adtech expert',
                            'a growth hacker.',
                        ]}
                        multiTextDelay={1000}
                        typeSpeed={60}
                    />
                </div>
            </Paper>
        </div>
      );
}